import React from 'react';
import { Helmet } from 'react-helmet-async';
import Advantages from './Advantages';

const Advantages_en = () => (
  <div className="lang-en">
    <Helmet>
      <title>Manufacturing Advantages</title>
      <meta
        name="description"
        content="Tang Wu Biotech integrates dual-plant production, international certifications, and high-quality food ingredient manufacturing."
      />
      <meta name="keywords" content="manufacturing, food safety, certifications" />
    </Helmet>
    <Advantages />
  </div>
);

export default Advantages_en;
